'use client';

import ServiceCard from '@/app/amenities-and-services/components/ServiceCard';
import Icon from '@/components/ui/AppIcon';

export default function AmenitiesSection() {
  const businessAmenities = [
    {
      icon: '💼',
      title: 'Dedicated Workspaces',
      description: 'Fully equipped home office setups with ergonomic furniture, high-speed internet, and professional lighting for productive remote work.',
      availability: 'All apartments'
    },
    {
      icon: '🤝',
      title: 'Meeting Room Access',
      description: 'Professional meeting spaces with video conferencing equipment, whiteboards, and presentation tools for client meetings and team collaborations.',
      availability: 'By reservation'
    },
    {
      icon: '🌐',
      title: 'High-Speed Internet',
      description: 'Enterprise-grade fiber optic connectivity with 100+ Mbps speeds, backup connections, and dedicated bandwidth for business-critical operations.',
      availability: '24/7 uptime'
    },
    {
      icon: '🔔',
      title: '24/7 Concierge Support',
      description: 'Round-the-clock assistance for travel arrangements, local recommendations, emergency support, and any special requests from your team.',
      availability: 'Always available'
    },
    {
      icon: '🍽️',
      title: 'Extended-Stay Programs',
      description: 'Specialized packages for relocating employees with flexible lease terms, furniture options, and local orientation support for seamless transitions.',
      availability: '1-12 months'
    },
    {
      icon: '📊',
      title: 'Flexible Billing',
      description: 'Direct invoicing with consolidated monthly statements, custom payment terms, and detailed expense reporting for simplified accounting.',
      availability: 'Custom terms'
    }
  ];

  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-flex items-center space-x-2 bg-primary/10 px-4 py-2 rounded-full mb-4">
            <Icon name="SparklesIcon" size={20} className="text-primary" />
            <span className="text-primary text-sm font-medium">Business-Focused Amenities</span>
          </div>
          <h2 className="text-3xl lg:text-5xl font-display font-bold text-text-primary mb-6">
            Everything Your Team Needs
          </h2>
          <p className="text-lg text-text-secondary">
            Premium amenities and services designed specifically for business travelers and corporate clients.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {businessAmenities?.map((amenity, index) => (
            <ServiceCard
              key={index}
              icon={amenity?.icon}
              title={amenity?.title}
              description={amenity?.description}
              availability={amenity?.availability}
            />
          ))}
        </div>
      </div>
    </section>
  );
}